'use client';
import Image from 'next/image'
import machineImage from '@/assets/images/machine.png'
import { Box, AppBar, Toolbar, Button, Typography, Container, Stack, Link } from '@mui/material';
import {useTranslations} from 'next-intl';
import SalterIcon from '@/assets/images/SalterIcon';
import { useRouter } from 'next/navigation';

export default function HomePage() {
  const t = useTranslations('HomePage');
  const router = useRouter();
  
  const navigateToLogin = () => {
    router.replace("/login");
  }

  return (
    <Box>
      <AppBar position="static" elevation={0} sx={{ bgcolor: 'transparent', p: 2}}>
        <Toolbar disableGutters sx={{ justifyContent: 'space-between', px: 2, alignItems: 'center'}}>
          <SalterIcon width={200} height={28} />
          <Stack direction="row" spacing={2} alignItems="center">
            <Link href="#" sx={{ color: 'white', textDecoration: 'none', mx: 2 }}>{t('shop')}</Link>
            <Button variant="contained" onClick={navigateToLogin}>
              {t('login')}
            </Button>
          </Stack>
        </Toolbar>
      </AppBar>
      
      <Container maxWidth="xl" sx={{ mt: 4, position: 'relative' }}>
        <Stack 
          direction={{ xs: 'column', md: 'row' }} 
          spacing={2}
          alignItems="center"
          justifyContent="space-between">
          <Box sx={{ maxWidth: '500px', zIndex: 2, mt: 4 }}>
            <Typography 
              component="h1" 
              variant="h2" 
              sx={{ 
                fontWeight: 'bold', 
                lineHeight: 1.2, 
                mb: 4,
                fontSize: { xs: '2.5rem', md: '3.5rem' }
              }}>
              {t('first_part_title_welcome')}
              <br />
              <Box component="span" sx={{ color: 'primary.main'}}>
                {t('second_part_title_welcome')}
              </Box>{' '}
              {t('third_part_title_welcome')}
            </Typography>
            <Button variant="outlined">
              {t('download_app')}
            </Button>
          </Box>
          
          <Box 
            sx={{ 
              position: 'relative',
              width: '60%',
              height: '70vh',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
            <Box sx={{ 
              position: 'relative', 
              zIndex: 1,
              width: '100%',
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
              <Image 
                src={machineImage} 
                alt="Salter machine" 
                style={{
                  width: 'auto',
                  height: '100%',
                  objectFit: 'contain',
                  objectPosition: 'center'
                }}
                priority
              />
              <Box component="ul">
                <li>{t('subtitle_welcome_register')}</li>
                <li>{t('subtitle_welcome_evolution')}</li>
                <li>{t('subtitle_welcome_compatibilities')}</li>
                <li>{t('subtitle_welcome_connect')}</li>
                <li>{t('subtitle_welcome_access')}</li>
              </Box>
            </Box>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
}